// extracted by mini-css-extract-plugin
module.exports = {"notifyItem":"style_notifyItem__NS_gX","icon":"style_icon__Dv7NU"};